import { Button,CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,  } from '@mui/material'
import { trackActivity } from '../../../../utils/mixpanel'

const SyncConfirmModal = ({ sync, onToggleModal, getResponseBack, isLoading,sectionName }) => {
  const handleItemClicked = (page_type) => {
      trackActivity('Item Clicked', { page_title: `${sectionName}`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="sm"
                fullWidth
                open={sync.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'>
                 Sync {sectionName}
                </DialogTitle>
                <DialogContent dividers>
                Are you sure you want to sync the {sectionName}? This action will overwrite the current data, and the previous data cannot be recovered.
                </DialogContent>
                <DialogActions sx={{marginRight: "15px"}}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>Cancel</Button>
                    <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); getResponseBack(); }}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Sync Now"} </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SyncConfirmModal;